import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import { Collapse } from '@mui';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { verifyPermissions } from '@utils/permission-utils';
import SidebarItem from './sidebar-item';
import './sidebar.scss';

const SidebarSection = ({ section: { items, permissions, title } }) => {
  const [open, setOpen] = useState(true);
  const toggleOpen = useCallback(() => setOpen(prev => !prev), []);

  if (!verifyPermissions(permissions)) {
    return null;
  }

  return (
    <div>
      <div onClick={toggleOpen} role="presentation" styleName="section-header">
        <span styleName="section-title">{title}</span>
        <span styleName={open ? 'section-chevron' : 'section-chevron chevron-closed'}>
          <ExpandMoreIcon fontSize="small" />
        </span>
      </div>
      <Collapse in={open}>
        <div>
          {items.map(item => <SidebarItem key={item.label} item={item} />)}
        </div>
      </Collapse>
    </div>
  );
};

SidebarSection.propTypes = {
  section: PropTypes.object
};

export default SidebarSection;
